export default "__VITE_ASSET__wRdKlqCk__"